<template>
    <div>
        <div class="com-model">
            <div class="top-bar">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/index/company' }">企业设置</el-breadcrumb-item>
                    <el-breadcrumb-item>企业认证</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="tip">提交次数限制：一天一次</div>
            <div class="content">
                <el-form ref="form" :rules="rules" :model="companyInfo" label-width="150px" >
                    <el-form-item label="管理者姓名" prop="legalName">
                        <el-input v-model="companyInfo.legalName"></el-input>
                    </el-form-item>
                    <el-form-item label="管理者联系电话" prop="legalPhone">
                        <el-input v-model="companyInfo.legalPhone"></el-input>
                    </el-form-item>
                    <el-form-item label="执照号码" prop="license">
                        <!-- <el-input v-model="companyInfo.industryId"></el-input> -->
                         <el-input v-model="companyInfo.license"></el-input>
                         <div class="tips">输入营业执照号码或统一社会信用代码</div>
                    </el-form-item>
                    <el-form-item label="营业执照" prop="licenseImg">
                        <el-upload
                            class="uploader-license"
                            action="/wapi/base/upload"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                            <img v-if="companyInfo.licenseImg" :src="companyInfo.licenseImg" class="avatar">
                            <div v-else>
                                <i class="el-icon-plus uploader-icon"></i>
                                <p>点击上传</p>
                                <p>营业执照</p>
                            </div>
                        </el-upload>
                         <div class="tips">格式要求：营业执照为图片，大小不超过1M</div>
                    </el-form-item>
                    <el-form-item style="margin-top: 60px; margin-bottom: 0; padding-bottom: 60px">
                            <div class="primary-btn button" @click="handleSubmit">提交审核</div>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
const qs = require("qs");
export default {
    data () {
        return {
            companyInfo: {
                license: '',
                licenseImg: '',
                legalPhone: '',
                legalName: ''
            },
            rules: {
                license: [
                    { required: true, message: '输入营业执照号码或统一社会信用代码', trigger: 'blur' }
                ],
                legalPhone: [
                    { required: true, message: '请输入管理者联系电话', trigger: 'blur' }
                ],
                legalName: [
                    { required: true, message: '请输入管理者姓名', trigger: 'blur' }
                ],
                licenseImg: [
                    { required: true, message: '请上传营业执照', trigger: 'change' }
                ]
            }
        }
    },
    mounted () {
        this.getInfo();
    },
    methods: {
        handleSubmit () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.axios.get('/wapi/company/applyAuth?'+ qs.stringify(this.companyInfo)).then(res => {
                        if(res.success){
                            this.$message({
                                message: '提交成功',
                                type:'success'
                            })
                            this.$router.go(-1)
                        }
                    })
                } else {
                    return false
                }
            })
        },
        beforeAvatarUpload(file){
            const isLtM = file.size / 1024 / 1024 < 1;
            if (!isLtM) {
                this.$message.error('上传图片大小不能超过 1MB!');
                return false
            }
            return true
        },
        handleAvatarSuccess(file){
             this.companyInfo.licenseImg = file.data
        },
         getInfo(){
            let url = '/wapi/company/get';
            this.axios.get(url).then(res => {
                if(res.success){
                    const data = res.data;
                    this.companyInfo = {
                        license: data.license || '',
                        licenseImg: data.licenseImg || '',
                        legalPhone: data.legalPhone || '',
                        legalName: data.legalName || ''
                    }
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
@import url('../../assets/less/company.less');
.com-model {
    border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// companyAuth.vue?49eb2d50